import axios from 'axios';
import { CONSTANTS_MODE } from "../utils/constants";
const { api } = CONSTANTS_MODE;

function getOptions(payload) {
    let option = {
            headers: {
                Authorization: 'Bearer ' + localStorage.getItem('accessToken').replace(/"/g, ''),
            }
    }
    if (payload) {
        option.params = payload
    }
    return option;
}

function handleError(error) {
    if (error.response) {
        if (error.response.status === 403) {
           return window.location.href = '/login';
        }
    }
    throw error;
}

export const requests = {
    get: (endpoint, payload) => {
        return axios.get(api + endpoint, getOptions(payload)).catch(error => { return handleError(error) });
    },
    post: (endpoint, payload) => {
        return axios.post(api + endpoint, payload, getOptions()).catch(error => { return handleError(error) });
    },
    patch: (endpoint, payload) => {
        return axios.patch(api + endpoint, payload, getOptions()).catch(error => { return handleError(error) });
    },
    delete: (endpoint) => {
        return axios.delete(api + endpoint, getOptions()).catch(error => { return handleError(error) });
    },
};




// WEBPACK FOOTER //
// ./src/api/request.js